import {useParams} from 'react-router-dom';

import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

import {ModuleEnum, PermissionOperationEnum} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {UserGroupDocumentTitle} from 'src/app/user-groups/userGroupHelpers';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import UserGroupForm from 'src/app/user-groups/UserGroupForm';

export const EditUserGroupPage = () => {
  useSetDocumentTitle(UserGroupDocumentTitle);
  const {id} = useParams();

  return (
    <ContentWrapper>
      {id !== undefined && <UserGroupForm id={Number(id)} mode="edit" />}
    </ContentWrapper>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.UserGroupEdit(':id', ':view'),
  element: <EditUserGroupPage />,
  module: ModuleEnum.UserGroups,
  operation: PermissionOperationEnum.Update,
  isPrivate: true,
  allowGlobalAdminBypass: true,
});

export default EditUserGroupPage;
